import {Observable, OperatorFunction} from 'rxjs';
import {bufferWhen, exhaustMap, share} from 'rxjs/operators';

/** Like bufferWhen, but doesn't emit empty buffers nor subscribes to the closing observable unnecessarily. */
export function bufferUnlessEmptyWhen<T>(closingSelector: () => Observable<any>): OperatorFunction<T, T[]> {
  return (source$) => {
    // Share the subscription because we're using the source observable twice.
    // TODO: Use publish() instead of share() so that source$ is multicasted for each subscriber to the
    // resulting observable.
    const sharedSource$ = source$.pipe(share());

    return sharedSource$.pipe(
      // Wait for the source observable to emit before subscribing to the closing observable.
      bufferWhen(() => sharedSource$.pipe(exhaustMap(closingSelector))),
    );
  };
}
